// @flow
import React, { type ComponentType } from 'react';

const LEAVE_MESSAGE =
  'Are you sure you want to navigate away from this page? \n Any unsaved changes you’ve made will be lost.';

type PropTypes = { show: boolean };

type StateTypes = { hasListener: boolean };

const onUnload: Function = event => {
  event.returnValue = LEAVE_MESSAGE; // eslint-disable-line no-param-reassign
  return LEAVE_MESSAGE;
};

const withLeaveDialog = (WrappedComponent: ComponentType<any>) =>
  class extends React.Component<PropTypes, StateTypes> {
    constructor(props: PropTypes) {
      super(props);
      this.state = { hasListener: false };
    }

    componentWillMount() {
      const { show } = this.props;
      if (show) {
        window.addEventListener('beforeunload', onUnload);
        this.setState({ hasListener: true });
      }
    }

    componentWillUnmount() {
      const { hasListener } = this.state;
      if (hasListener) {
        window.removeEventListener('beforeunload', onUnload);
        this.setState({ hasListener: false });
      }
    }

    render() {
      return <WrappedComponent {...this.props} />;
    }
  };

export default withLeaveDialog;



// WEBPACK FOOTER //
// ./src/components/withLeaveDialog.jsx